module.exports = __webpack_public_path__ + "static/media/icon-location-pin.5ea055fa.svg";